import { computeHeadingLevel } from "@testing-library/react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import Creatable from "react-select/creatable";
import sendRequestUsers from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";
import defaultImage from "assets/images/Logos/Group 22.png";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import toast from "react-hot-toast";
import laptop from "../../assets/images/home/laptop.png";
export default function AddRepairsModal({ orderUpdater }) {
  const ValidationDetailsRepair = () => {
    let isValidate = true;
    console.log("temp value", tempValue);
    if (tempValue.title) {
      setTempValidateValues(prev => {
        return { ...prev, title: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, title: false };
      });
      isValidate = false;
    }
    if (tempValue.main_discount > 0) {
      setTempValidateValues(prev => {
        return { ...prev, main_discount: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, main_discount: false };
      });
      isValidate = false;
    }

    if (tempValue.desc) {
      setTempValidateValues(prev => {
        return { ...prev, desc: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, desc: false };
      });
      isValidate = false;
    }
    if (tempValue.number) {
      setTempValidateValues(prev => {
        return { ...prev, number: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, number: false };
      });
      isValidate = false;
    }

    if (parseInt(tempValue.main_price) > parseInt(tempValue.main_discount)) {
      setTempValidateValues(prev => {
        return { ...prev, main_price: true };
      });
    } else {
      setTempValidateValues(prev => {
        return { ...prev, main_price: false };
      });
      isValidate = false;
    }
    return isValidate;
  };
  const Validation = () => {
    let temp = true;
    if (phoneNumberValidation(addModalData.userName.phoneNumber)) {
      setValidateValues(prev => {
        return { ...prev, phoneNumber: true };
      });
    } else {
      temp = false;
      setValidateValues(prev => {
        return { ...prev, phoneNumber: false };
      });
    }
    if (addModalData.addDevice.length > 0) {
      setValidateValues(prev => {
        return { ...prev, addDevice: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, addDevice: false };
      });

      temp = false;
    }

    if (addModalData.userName) {
      setValidateValues(prev => {
        return { ...prev, userName: true };
      });
    } else {
      temp = false;

      setValidateValues(prev => {
        return { ...prev, userName: false };
      });
    }
    if (addModalData.sendtm != "") {
      setValidateValues(prev => {
        return { ...prev, sendtm: true };
      });
    } else {
      setValidateValues(prev => {
        return { ...prev, sendtm: false };
      });
    }
    return true;
  };
  const phoneNumberValidation = phoneNumber => {
    return /^09\d{9}$/.test(phoneNumber);
  };
  const [userOption, setUserOption] = useState([
    // { value: "0", label: "arefe", phoneNumber: "09305382470" },
    // { value: "1", label: "maryam", phoneNumber: "09211702120" },
    // { value: "2", label: "zahra", phoneNumber: "091239803636" },
  ]);
  const [validateValues, setValidateValues] = useState({
    userName: true,
    phoneNumber: true,
    totalPrice: true,
    sendtm: true,
    // trackingN: true,
    rescipient_mobile: true,
    rescipient_address: true,
    debtAmount: true,
    paid_amount: true
  });
  const [tempValidateValues, setTempValidateValues] = useState({
    title: true,
    main_price: true,
    main_discount: true,
    choseFile: true,
    desc: true,
    number: true
  });
  const [addModalData, setAddModalData] = useState({
    userName: "",
    phoneNumber: "",
    totalPrice: "",
    sendtm: "",
    paid_amount: "",
    //trackingN: "",
    debtAmount: "",
    desc: "",
    Discount: "",
    amount: "",
    title: "",
    choseFile: "",
    rescipient_mobile: "",
    rescipient_fname: "",
    rescipient_lname: "",
    rescipient_address: "",
    rescipient_postalcode: "",
    addDevice: []
  });

  const [tempValue, setTempValue] = useState({
    title: "",
    main_price: "",
    id: 0,
    main_discount: "",
    desc: "",
    choseFile: "",
    number: ""
  });
  const RemoveCounter = index => {
    let newArray = addModalData.addDevice.filter((value, index2, array) => {
      if (index == index2) {
        return false;
      } else {
        return true;
      }
    });
    setAddModalData(prev => {
      return { ...prev, addDevice: [...newArray] };
    });
  };
  const changeHandler = (value, type) => {
    setAddModalData(prev => {
      return { ...prev, [type]: value };
    });
  };
  const [newUser, setNewUser] = useState({ fName: "", lName: "", mobile: "" });
  const [displayStatus, setDisplayStatus] = useState("d-none");
  console.log("tempvalidation", tempValidateValues);

  useEffect(() => {
    sendRequestUsers("Find_users").then(({ data }) => {
      setUserOption([
        { value: "create", label: "کاربر جدید" },
        ...data.map(value => {
          return {
            value: value.id,
            label: value.fname + " " + value.lname,
            phoneNumber: value.mobile
          };
          // ...data,
        })
      ]);
    });
  }, []);
  console.log("addModalData", addModalData);
  console.log("newUser", newUser);
  const sendAddModalData = () => {
    let fd = new FormData();
    console.log(addModalData);
    fd.append("sendtm", addModalData.sendtm.unix);
    //fd.append("despription", addModalData.desc);
    fd.append("rescipient_fname", addModalData.rescipient_fname);
    fd.append("rescipient_lname", addModalData.rescipient_lname);
    fd.append("rescipient_mobile", addModalData.rescipient_mobile);
    fd.append("rescipient_postalcode", addModalData.rescipient_postalcode);
    fd.append("rescipient_address", addModalData.rescipient_address);
    //fd.append("paid_amount", addModalData.paid_amount);
    fd.append("send_trackingcode", "");

    fd.append("type", "1");
    fd.append("order_type", "1");
    if (addModalData.userName.value == "create") {
      fd.append("user_fname", newUser.fName);
      fd.append("user_lname", newUser.lName);
      fd.append("user_mobile", newUser.mobile);
    } else {
      fd.append("uid", addModalData.userName.value);
    }
    for (let i = 0; i < addModalData.addDevice.length; i++) {
      fd.append(`order_items[${i}][title]`, addModalData.addDevice[i].title);
      fd.append(
        `order_items[${i}][main_price]`,
        addModalData.addDevice[i].main_price
      );
      fd.append(
        `order_items[${i}][discount]`,
        addModalData.addDevice[i].main_discount
      );
      fd.append(`order_items[${i}][number]`, addModalData.addDevice[i].number);
      fd.append(
        `order_items[${i}][description]`,
        addModalData.addDevice[i].despription
      );
      fd.append(`order_items[${i}][number]`, addModalData.addDevice[i].number);

      fd.append(`file_${i}`, addModalData.addDevice[i].choseFile);
      // }
    }
    sendRequest2("add_repair_order_new", fd).then(({ data }) => {
      console.log("data.status", data);
      if (data.status == 1) {
        toast.success("تعمیر با موفقیت ثبت شد.");
        // setUpdateProduct((prev) => !prev);
        document.querySelector("#AddRepairsModal .btn-close").click();
        orderUpdater(prev => {
          return !prev;
        });
        setAddModalData({
          userName: "",
          phoneNumber: "",
          totalPrice: "",
          sendtm: "",
          paid_amount: "",
          //trackingN: "",
          debtAmount: "",
          desc: "",
          Discount: "",
          amount: "",
          title: "",
          choseFile: "",
          rescipient_mobile: "",
          rescipient_fname: "",
          rescipient_lname: "",
          rescipient_address: "",
          rescipient_postalcode: "",
          addDevice: []
        });
        setTempValue({
          title: "",
          price: "",
          id: 0,
          number: 0,
          discount: 0,
          choseFile: "",
          url: ""
        });
      } else {
        toast.error("مشکلی در ثبت تعمیر پیش آمده است.");
      }
    });
  };
  console.log("validValues", validateValues);

  const modalVar = (
    <div className="modal fade addOrder" id="AddRepairsModal">
      <div className="modal-dialog modal-lg ">
        {/* {Object.keys(selectedItem).length && ( */}
        <div
          className="modal-content"
          style={{
            backgroundColor: "white",
            borderRadius: "15px",
            padding: "30px"
          }}
        >
          <div class="modal-header">
            <h5 class="modal-title"> افزودن تعمیرات</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className=" d-flex order-item2 mx-4 mt-2 p-4">
            <div>
              <form className="form row w-100">
                <div
                  style={{
                    backgroundColor: "#203b8c",
                    width: "200px",
                    borderRadius: "30px 0px 0px 30px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    مشخصات کاربر:
                  </p>
                </div>
                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="name"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        نام کاربر:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <Creatable
                        options={userOption}
                        // isMulti
                        id="name"
                        value={addModalData.userName}
                        onChange={value => {
                          changeHandler(value, "userName");
                          if (value.value == "create") {
                            setDisplayStatus("d-block");
                          } else {
                            setDisplayStatus("d-none");
                          }
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.userName == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا نام کاربر را وارد کنید.
                      </p>
                    </div>
                  </div>
                  {addModalData.userName.value != "create" ? (
                    <div className="container-responsive col-12 col-lg-6 d-flex mt-2">
                      <div
                        className="label"
                        style={{
                          textAlign: "right",
                          marginTop: "5px"
                        }}
                      >
                        <label
                          htmlFor="phoneNumber"
                          style={{ color: "#707070", whiteSpace: "nowrap" }}
                        >
                          موبایل کاربر :
                        </label>
                      </div>

                      <div className="input" style={{ direction: "rtl" }}>
                        <input
                          type="text"
                          required
                          className="form-control"
                          id="phoneNumber"
                          value={
                            addModalData.userName.phoneNumber == undefined
                              ? ""
                              : addModalData.userName.phoneNumber
                          }
                          onChange={e => {
                            if (
                              addModalData.userName.__isNew__ &&
                              !isNaN(e.target.value)
                            ) {
                              setAddModalData(prev => {
                                return {
                                  ...prev,
                                  userName: {
                                    ...prev.userName,
                                    phoneNumber: e.target.value
                                  }
                                };
                              });
                            }
                          }}
                        />
                        <p
                          style={{
                            color: "red",
                            fontSize: "13px",
                            visibility:
                              validateValues.phoneNumber == ""
                                ? "visible"
                                : "hidden"
                          }}
                        >
                          شماره همراه وارد شده اشتباه است.
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* ایجادکاربر جدید */}
                  <div
                    className={`d-flex pr  ${displayStatus} rounded`}
                    style={{ border: "1px dashed lightgray" }}
                  >
                    <div className="container  p-1">
                      <div className="label">
                        <label style={{ whiteSpace: "nowrap" }}>
                          نام کاربر:
                        </label>
                      </div>
                      <div className="input2">
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.fName}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, fName: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="container  p-1">
                      <div className="label">
                        <label style={{ whiteSpace: "nowrap" }}>
                          فامیل کاربر:
                        </label>
                      </div>
                      <div className="input2">
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.lName}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, lName: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="container  p-1">
                      <div className="label">
                        <label style={{ whiteSpace: "nowrap" }}>
                          موبایل کاربر:
                        </label>
                      </div>
                      <div className="input2">
                        <input
                          className="form-control"
                          type="text"
                          value={newUser.mobile}
                          onChange={e => {
                            setNewUser(prev => {
                              return { ...prev, mobile: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    backgroundColor: "#203b8c",
                    marginTop: "20px",

                    width: "200px",
                    borderRadius: "30px 0px 0px 30px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    مشخصات گیرنده:
                  </p>
                </div>
                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px",
                    paddingBottom: "30px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_fname"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        نام گیرنده:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_fname"
                        className="form-control"
                        id="rescipient_fname"
                        value={addModalData.rescipient_fname}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_fname");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_lname"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        فامیلی گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_lname"
                        className="form-control"
                        id="rescipient_lname"
                        value={addModalData.rescipient_lname}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_lname");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        //width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_mobile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        موبایل گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_mobile"
                        className="form-control"
                        id="rescipient_mobile"
                        value={addModalData.rescipient_mobile}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_mobile");
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        //width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_postalcode"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        کدپستی گیرنده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="rescipient_postalcode"
                        className="form-control"
                        id="rescipient_postalcode"
                        value={addModalData.rescipient_postalcode}
                        onChange={e => {
                          changeHandler(
                            e.target.value,
                            "rescipient_postalcode"
                          );
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 d-flex container-responsive  mt-2">
                    <div
                      className="labelReceptor"
                      style={{
                        //width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="rescipient_address"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        آدرس گیرنده :
                      </label>
                    </div>

                    <div
                      className="inputReceptor"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <textarea
                        type="text"
                        required
                        name="rescipient_address"
                        className="form-control w-100"
                        id="rescipient_address"
                        value={addModalData.rescipient_address}
                        onChange={e => {
                          changeHandler(e.target.value, "rescipient_address");
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    backgroundColor: "#203b8c",
                    width: "200px",
                    borderRadius: "30px 0px 0px 30px",
                    marginTop: "20px"
                  }}
                >
                  <p
                    style={{
                      marginTop: "10px",
                      color: "white"
                    }}
                  >
                    مشخصات تعمیر:
                  </p>
                </div>
                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="sendtm"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        تاریخ ارسال:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        inputClass={"date-picker-style form-control"}
                        calendarPosition="bottom-right"
                        id="sendtm"
                        value={addModalData.sendtm}
                        onChange={value => {
                          changeHandler(value, "sendtm");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.sendtm == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا تاریخ ارسال را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        //width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="totalPrice"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مبلغ کل:
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="totalPrice"
                        value={addCommas(
                          addModalData.addDevice.reduce(
                            (total, currentValue) => {
                              return (
                                total +
                                parseInt(
                                  // currentValue.main_price -
                                  currentValue.main_discount *
                                    currentValue.number
                                )
                              );
                            },
                            0
                          )
                        )}
                        onChange={e => {
                          changeHandler(e.target.value, "totalPrice");
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            validateValues.totalPrice == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا مبلغ کل را وارد کنید.
                      </p>
                    </div>
                  </div>
                  {/* <div className="col-12 col-lg-6 d-flex mt-2 container-responsive">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px",
                      }}
                    >
                      <label
                        htmlFor="paid_amount"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مبلغ پرداخت شده :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl",
                        // width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="paid_amount"
                        value={addCommas(addModalData.paid_amount)}
                        onChange={(e) => {
                          if (!isNaN(addModalData.paid_amount))
                            setAddModalData((prev) => {
                              return {
                                ...prev,
                                paid_amount: removeCommas(e.target.value),
                              };
                            });
                        }}
                      />
                      <p></p>
                    </div>
                  </div> */}
                </div>
                <div className="d-flex">
                  <div
                    style={{
                      backgroundColor: "#203b8c",
                      width: "200px",
                      borderRadius: "30px 0px 0px 30px",
                      paddingRight: "5px",
                      marginTop: "20px"
                    }}
                  >
                    <p
                      style={{
                        marginTop: "10px",
                        color: "white"
                      }}
                    >
                      دستگاه:
                    </p>
                  </div>
                  <button
                    style={{
                      height: "30px",
                      marginTop: "25px",
                      marginRight: "5px",
                      backgroundColor: "white",
                      border: "none",
                      fontSize: "20px"
                    }}
                    type="button"
                    onClick={() => {
                      setTempValue({
                        title: "",
                        main_price: "",
                        id: 0,
                        main_discount: "",
                        desc: "",
                        choseFile: "",
                        number: ""
                      });
                      console.log(
                        "ValidationDetailsRepair()",
                        ValidationDetailsRepair()
                      );
                      if (ValidationDetailsRepair()) {
                        setAddModalData(prev => {
                          return {
                            ...prev,
                            addDevice: [
                              ...prev.addDevice,
                              {
                                main_discount: tempValue.main_discount,
                                main_price: tempValue.main_price,
                                despription: tempValue.desc,
                                title: tempValue.title,
                                choseFile: tempValue.choseFile,
                                number: tempValue.number
                              }
                            ]
                          };
                        });
                      }
                    }}
                  >
                    <FcPlus></FcPlus>
                  </button>
                </div>

                <div
                  className="row pt-3"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderRight: "1px solid #dee2e6",
                    marginTop: "20px",
                    marginRight: "20px"
                  }}
                >
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="title"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        عنوان :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="title"
                        value={tempValue.title}
                        onChange={e => {
                          // if (!isNaN(e.target.value))
                          setTempValue(prev => {
                            return { ...prev, title: e.target.value };
                          });
                          console.log(tempValue.title);
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            tempValidateValues.title == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا عنوان را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="amount"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مبلغ :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        name="main_price"
                        className="form-control"
                        id="amount"
                        value={addCommas(tempValue.main_price)}
                        onChange={e => {
                          if (!isNaN(tempValue.main_price))
                            setTempValue(prev => {
                              return {
                                ...prev,
                                main_price: removeCommas(e.target.value)
                              };
                            });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            tempValidateValues.main_price == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا مبلغ را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="number"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        تعداد :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl"
                        // width: "65%",
                      }}
                    >
                      <input
                        type="text"
                        name="number"
                        required
                        className="form-control"
                        id="number"
                        value={tempValue.number}
                        onChange={e => {
                          setTempValue(prev => {
                            return {
                              ...prev,
                              number: e.target.value
                            };
                          });
                        }}
                      />

                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility: !tempValidateValues.number
                            ? "visible"
                            : "hidden"
                        }}
                      >
                        لطفا تعداد را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive  mt-2">
                    <div
                      className="label"
                      style={{
                        //width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="Discount"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        مبلغ با تخفیف :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" //width: "75%"
                      }}
                    >
                      <input
                        type="text"
                        required
                        className="form-control"
                        id="Discount"
                        value={addCommas(tempValue.main_discount)}
                        onChange={e => {
                          if (
                            removeCommas(e.target.value) >= tempValue.main_price
                          ) {
                            toast.error(
                              "مبلغ تخفیف نمی تواند بیشتر از قیمت کل باشد!"
                            );
                          } else {
                            if (!isNaN(tempValue.main_discount))
                              setTempValue(prev => {
                                return {
                                  ...prev,
                                  main_discount: removeCommas(e.target.value)
                                };
                              });
                          }
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            tempValidateValues.main_discount == ""
                              ? "visible"
                              : "hidden"
                        }}
                      >
                        لطفا مبلغ با تخفیف را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-6 d-flex container-responsive mt-2">
                    <div
                      className="label"
                      style={{
                        // width: "35%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="choseFile"
                        style={{ color: "#707070", whiteSpace: "nowrap" }}
                      >
                        انتخاب فایل :
                      </label>
                    </div>

                    <div
                      className="input"
                      style={{
                        direction: "rtl" // width: "75%"
                      }}
                    >
                      <div className="mb-3">
                        <input
                          className="form-control"
                          type="file"
                          id="choseFile"
                          // value={tempValue.choseFile}
                          onChange={e => {
                            setTempValue(prev => {
                              return { ...prev, choseFile: e.target.files[0] };
                            });
                            console.log("image2000", tempValue.choseFile);
                          }}
                        />
                      </div>
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px"
                        }}
                      >
                        {/* لطفاتصویر مورد نطر وارد کنید. */}
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-lg-12 d-flex container-responsive mt-2">
                    <div
                      className="labelAddress"
                      style={{
                        width: "18%",
                        textAlign: "right",
                        marginTop: "5px"
                      }}
                    >
                      <label
                        htmlFor="desc"
                        style={{
                          color: "#707070",
                          whiteSpace: "nowrap",
                          fontSize: "14px"
                        }}
                      >
                        توضیحات :
                      </label>
                    </div>
                    <div
                      className="inputAddress"
                      style={{
                        direction: "rtl",
                        width: "100%"
                      }}
                    >
                      <textarea
                        required
                        className="form-control"
                        id="desc"
                        value={tempValue.desc}
                        onChange={e => {
                          setTempValue(prev => {
                            return { ...prev, desc: e.target.value };
                          });
                        }}
                      />
                      <p
                        style={{
                          color: "red",
                          fontSize: "13px",
                          visibility:
                            tempValidateValues.desc == "" ? "visible" : "hidden"
                        }}
                      >
                        لطفا توضیحات را وارد کنید.
                      </p>
                    </div>
                  </div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "red",
                      visibility:
                        validateValues.addDevice == "" ? "visible" : "hidden"
                    }}
                  >
                    لیست دستگاهای تعمیر نباید خالی باشد.
                  </p>

                  {addModalData.addDevice.map((value, index) => {
                    return (
                      <div
                        className="row pt-3 mt-4"
                        style={{
                          //borderBottom: "1px solid #dee2e6",
                          marginBottom: "15px",
                          marginRight: "5px"
                        }}
                      >
                        <div className="col-12 col-lg-1">
                          {value.choseFile == "" ? (
                            <img
                              src={laptop}
                              style={{
                                width: "50px",
                                height: "50px",
                                border: "1px solid #F5F5F5"
                              }}
                            />
                          ) : (
                            <img
                              src={URL.createObjectURL(value.choseFile)}
                              style={{
                                width: "50px",
                                height: "50px",
                                border: "1px solid #F5F5F5"
                              }}
                            />
                          )}
                        </div>
                        <div className="box-txt col-10  mr-5">
                          <p
                            style={{
                              fontSize: "13px",
                              marginTop: "15px",
                              marginRight: "10px"
                            }}
                          >
                            دستگاهی با عنوان:
                            <span
                              style={{
                                marginRight: "5px",
                                marginLeft: "5px",
                                color: "red"
                              }}
                            >
                              {value.title}
                            </span>
                            به مبلغ:
                            <span
                              style={{
                                marginRight: "5px",
                                marginLeft: "5px",
                                color: "red"
                              }}
                            >
                              {addCommas(value.main_price)}
                            </span>
                            تومان باتعداد :
                            <span
                              style={{
                                marginRight: "5px",
                                marginLeft: "5px",
                                color: "red"
                              }}
                            >
                              {value.number}
                            </span>
                            را به قیمت تخفیف :
                            <span
                              style={{
                                marginRight: "5px",
                                marginLeft: "5px",
                                color: "red"
                              }}
                            >
                              {addCommas(
                                value.main_price - value.main_discount
                              )}
                            </span>
                            تومان را با قیمت نهایی :
                            <span
                              style={{
                                marginRight: "5px",
                                marginLeft: "5px",
                                color: "red"
                              }}
                            >
                              {addCommas(
                                // (value.main_price - value.main_discount) *
                                //   value.number
                                value.main_discount * value.number
                              )}
                            </span>
                            اضافه کردید.
                          </p>
                        </div>
                        <div
                          className="col-1"
                          style={{ width: "5px", textAlign: "left" }}
                        >
                          <button
                            type="button"
                            style={{
                              border: "none",
                              backgroundColor: "#f9f7f8",
                              backgroundColor: "white",
                              fontSize: "20px",
                              marginTop: "15px"
                            }}
                            onClick={() => {
                              RemoveCounter(index);
                            }}
                          >
                            <HiMinusCircle
                              style={{ color: "#35b8e0" }}
                            ></HiMinusCircle>
                          </button>
                        </div>
                        <div className="parent">
                          <div
                            className=""
                            style={{ width: "12%", marginTop: "10px" }}
                          >
                            <label
                              style={{
                                color: "#707070",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                                fontSize: "15px"
                              }}
                            >
                              توضیحات:
                            </label>
                          </div>
                          <div
                            className="col-12 col-lg-10"
                            style={{
                              width: "85%",
                              marginTop: "13px"
                            }}
                          >
                            <p
                              style={{
                                color: "#707070",
                                whiteSpace: "nowrap",
                                fontSize: "13px"
                              }}
                            >
                              {/* {value.desc} */}
                              {value.despription == undefined
                                ? value.description
                                : value.despription}
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            borderBottom: "1px solid #dee2e6",
                            height: "3px",
                            marginRight: "5px"
                          }}
                        ></div>
                      </div>
                    );
                  })}
                </div>

                <div className="d-flex justify-content-end mt-2">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      if (Validation() && addModalData.addDevice != "") {
                        sendAddModalData();
                      }
                    }}
                  >
                    افزودن
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}
